import { Link } from "react-router-dom";

interface NotFoundBlockProps {
  title?: string;
  description?: string;
  backTo?: string;
  backLabel?: string;
}

export default function NotFoundBlock({
  title = "内容不存在",
  description = "这个链接可能已经失效，或者内容编号有误。你可以回到上一级页面继续浏览。",
  backTo = "/",
  backLabel = "返回首页",
}: NotFoundBlockProps) {
  return (
    <div className="mx-auto flex w-full max-w-portal flex-col items-center justify-center px-4 py-20 text-center md:py-28">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-500">
        <i className="ri-error-warning-line text-3xl" />
      </span>
      <p className="mt-5 font-label text-xs uppercase tracking-[0.28em] text-foreground-400">404 · 页面不存在</p>
      <h1 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">{title}</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to={backTo}
          className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
        >
          {backLabel}
        </Link>
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-full border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}